/** Duration in milliseconds after which feedback counts expire and banner should be hidden */
export const FEEDBACK_COUNT_EXPIRY_TIME = 10 * 60 * 1000; // 10 minutes
